module.exports = __webpack_public_path__ + "img/sharetips_img@2x.7669a281.png";